import { StateCreator } from 'zustand';
import { YourDetailsSlice } from './yourDetails';
import { IssueDetailsSlice } from './issueDetails';
import { ReportObjectType } from '@abvehicles/types/api-types';
import {
  getIssueLengthApiValue,
  getIssueTypeApiValue,
} from '@abvehicles/types/issue-types';

// placeholder - to be defined once API schema is available
export type CombinedSlice = {
  getDataForSubmission: () => any;
};

export const createCombinedSlice: StateCreator<
  IssueDetailsSlice & YourDetailsSlice,
  [],
  [],
  CombinedSlice
> = (set, get) => ({
  getDataForSubmission: () => {
    const {
      userDetails: { firstName, lastName, email, contactId },
      sessionId,
      wantConfirmationEmail,
      issueType,
      issueLength,
      serviceLocationDetails,
      fileDetailsObjects,
      vehicleDetails,
      uploadedImagesBlob,
    } = get();

    const ReportObject: ReportObjectType = {
      issue_type: getIssueTypeApiValue(issueType.issueType),
      other_issue: issueType.additionalInfo ? issueType.additionalInfo : null,
      duration: getIssueLengthApiValue(issueLength),
      registration_number: vehicleDetails.registrationNumber
        ? vehicleDetails.registrationNumber
        : null,
      make: vehicleDetails.make ? vehicleDetails.make : null,
      model: vehicleDetails.model ? vehicleDetails.model : null,
      colour: vehicleDetails.colour ? vehicleDetails.colour : null,
    };

    const ServiceLocationObject = {
      address_line_1: serviceLocationDetails.address_line_1,
      address_line_2: serviceLocationDetails.address_line_2,
      town_city: serviceLocationDetails.town_city,
      country: serviceLocationDetails.country,
      county: serviceLocationDetails.county,
      easting: serviceLocationDetails.easting,
      northing: serviceLocationDetails.northing,
      latitude: serviceLocationDetails.latitude,
      longitude: serviceLocationDetails.longitude,
      postcode: serviceLocationDetails.postcode,
      UPRN: serviceLocationDetails.UPRN,
      USRN: serviceLocationDetails.USRN,
      additional_details: serviceLocationDetails.additional_details || '',
    };

    const ChannelObject = {
      channel: 'Online',
      platform: 'React',
      session_id: sessionId,
    };

    const ReporterObject = wantConfirmationEmail
      ? {
          can_be_contacted: wantConfirmationEmail,
          contact_id: contactId ? contactId : null,
          name: {
            first_name: firstName,
            middle_name: null,
            last_name: lastName,
          },
          contact_details: {
            email_address: email,
            phone_number: '',
          },
        }
      : undefined;

    const FileCollectionObject =
      fileDetailsObjects.length > 0
        ? {
            external: false,
            files: fileDetailsObjects.map((file) => {
              if (!file.path) {
                return {
                  ...file,
                  path: uploadedImagesBlob.filter(
                    (item) => item.filename === file.name,
                  )[0].blob_uri,
                };
              }
              return file;
            }),
          }
        : undefined;

    return {
      ReportObject,
      ServiceLocationObject,
      ChannelObject,
      ReporterObject,
      FileCollectionObject,
    };
  },
});
